import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconDeliveringOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 101 101'
      fill={fill || 'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.936279'
        y='1'
        width='99'
        height='99'
        rx='15.5'
        fill='white'
        stroke='#D6D6D6'
      />
      <path
        d='M88.4296 49.4046C89.6796 49.4296 90.8616 50.3836 91.3616 51.2846C92.2886 52.9466 91.9816 54.8986 90.6276 55.6806C89.2686 56.4676 87.3986 55.7696 86.4456 54.1236C85.4976 52.4776 85.8256 50.5096 87.1846 49.7276C87.5906 49.4926 88.0126 49.3986 88.4296 49.4046ZM49.2716 32.4636H58.2036C59.6206 32.4636 60.5006 32.9786 61.4846 33.7756L71.5876 42.0046C72.1506 42.4626 72.1296 43.3166 71.3996 43.3166H49.2716C48.5476 43.3166 47.9586 42.7286 47.9586 42.0046V33.7756C47.9586 33.0516 48.5476 32.4636 49.2716 32.4636ZM29.0386 32.4636H41.7456C42.6096 32.4636 43.3086 33.1616 43.3086 34.0266V41.7536C43.3086 42.6186 42.6106 43.3166 41.7456 43.3166H24.1536C23.2896 43.3166 22.9556 42.5146 23.3616 41.7536L27.4756 34.0266C27.8826 33.2646 28.1696 32.4636 29.0386 32.4636ZM27.7526 27.9316C25.3986 27.9316 24.4716 29.1556 23.5086 31.3026L16.1906 45.4356C15.5026 46.9616 15.2686 48.0336 15.2686 49.6336V58.4136C15.2686 60.3296 16.4606 63.0636 19.2376 63.0636H21.7526C21.7526 56.5536 27.0286 51.2726 33.5386 51.2726C36.6626 51.2726 39.6626 52.5176 41.8756 54.7256C44.0846 56.9386 45.3286 59.9386 45.3286 63.0636H59.8276C59.8276 56.5536 65.1076 51.2726 71.6176 51.2726C74.7426 51.2726 77.7366 52.5176 79.9506 54.7256C82.1586 56.9386 83.4036 59.9386 83.4036 63.0636H91.2936C93.1996 63.0636 94.7316 61.2616 94.7316 59.0326V49.4816C94.7316 47.8526 93.3776 46.9246 91.7936 46.5396L83.1796 44.4566C80.8526 43.8936 79.8256 43.2896 78.2326 41.6806L64.8376 30.3276C63.1816 28.6606 61.7126 27.9316 59.3586 27.9316H27.7526Z'
        fill='url(#paint0_linear_1340:7330)'
      />
      <path
        d='M33.5386 72.0687C28.5646 72.0687 24.5286 68.0377 24.5286 63.0647C24.5286 58.0907 28.5646 54.0557 33.5386 54.0557C35.9286 54.0557 38.2206 55.0087 39.9076 56.6957C41.5956 58.3837 42.5476 60.6747 42.5476 63.0657C42.5476 68.0377 38.5126 72.0687 33.5386 72.0687ZM33.5386 66.4397C35.4026 66.4397 36.9186 64.9287 36.9186 63.0647C36.9186 61.1997 35.4026 59.6847 33.5386 59.6847C31.6746 59.6847 30.1586 61.1997 30.1586 63.0647C30.1586 64.9277 31.6746 66.4397 33.5386 66.4397Z'
        fill='url(#paint1_linear_1340:7330)'
      />
      <path
        d='M71.6125 72.0687C66.6445 72.0687 62.6085 68.0377 62.6085 63.0647C62.6085 58.0907 66.6445 54.0557 71.6125 54.0557C74.0035 54.0557 76.2945 55.0087 77.9815 56.6957C79.6735 58.3837 80.6225 60.6747 80.6225 63.0657C80.6225 68.0377 76.5865 72.0687 71.6125 72.0687ZM71.6125 66.4397C73.4765 66.4397 74.9925 64.9287 74.9925 63.0647C74.9925 61.1997 73.4765 59.6847 71.6125 59.6847C69.7485 59.6847 68.2375 61.1997 68.2375 63.0647C68.2375 64.9277 69.7485 66.4397 71.6125 66.4397Z'
        fill='url(#paint2_linear_1340:7330)'
      />
      <path
        d='M20.4939 30.2192H5.37054'
        stroke='url(#paint3_linear_1340:7330)'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M18.6085 34.4589H7.68805'
        stroke='url(#paint4_linear_1340:7330)'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M16.7454 38.8649H9.46883'
        stroke='url(#paint5_linear_1340:7330)'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1340:7330'
          x1='31.426'
          y1='36.4648'
          x2='108.229'
          y2='74.8697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1340:7330'
          x1='31.426'
          y1='36.4648'
          x2='108.229'
          y2='74.8697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1340:7330'
          x1='31.426'
          y1='36.4648'
          x2='108.229'
          y2='74.8697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1340:7330'
          x1='8.44564'
          y1='30.4126'
          x2='9.42568'
          y2='34.5292'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_1340:7330'
          x1='9.90854'
          y1='34.6522'
          x2='11.2021'
          y2='38.5757'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_1340:7330'
          x1='10.9484'
          y1='39.0582'
          x2='12.6774'
          y2='42.5527'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Icon(IconDeliveringOrder)
